import React from 'react';
import classNames from 'classnames/bind';
import { useSpring, animated } from '@react-spring/web';
import PropTypes from 'prop-types';
import styles from './assets/styles.scss';

import ImgLangEn from './assets/images/english.png';
import ImgLangCn from './assets/images/chinese.png';
import ImgLangJa from './assets/images/japanese.png';
import ImgLangEs from './assets/images/spanish.png';
import ImgLangRu from './assets/images/russian.png';
import ImgLangNl from './assets/images/dutch.png';
import IconArrowDown from '../Game/assets/images/arrow-down.svg?inline';

const cx = classNames.bind(styles);

const languages = {
  en: {
    icon: ImgLangEn,
    name: 'English',
  },
  zh_cn: {
    icon: ImgLangCn,
    name: '中文',
  },
  ja: {
    icon: ImgLangJa,
    name: '日本語',
  },
  es: {
    icon: ImgLangEs,
    name: 'Español',
  },
  ru: {
    icon: ImgLangRu,
    name: 'Русский',
  },
  nl: {
    icon: ImgLangNl,
    name: 'Nederlands',
  },
};

function getLangCode() {
  if (window.bablic) {
    return window.bablic.getLocale();
  }
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('locale') || 'en';
}

const optionHeight = 46;
const dropdownHeight = optionHeight * (Object.entries(languages).length - 1);

export default function LangSwitcher({
  isOpen, toggleOpen, reverse, onOpened,
}) {
  const [dropdownStyle] = useSpring(
    {
      to: { height: isOpen ? dropdownHeight : 0 },
      onRest: () => isOpen && onOpened(),
    },
    [isOpen]
  );

  function switchLanguage(newLanguage) {
    window.bablic.redirectTo(newLanguage, { forceRedirect: true });
    toggleOpen();
  }
  const selectedLang = languages[getLangCode()];
  return (
    <div className={cx('lang-switcher', { reverse })}>
      <button
        className={cx('dropdown-trigger')}
        type="button"
        onClick={() => toggleOpen()}
        style={{ height: optionHeight }}
      >
        <img src={selectedLang.icon} alt={selectedLang.name} />
        <span className={cx('small')}>{selectedLang.name}</span>
        <IconArrowDown className={cx({ rotate: isOpen })} />
      </button>
      <animated.div style={dropdownStyle} className={cx('dropdown')}>
        {Object.entries(languages)
          .filter(([key]) => key !== getLangCode())
          .map(([key, { icon, name }]) => (
            <button key={key} type="button" onClick={() => switchLanguage(key)} style={{ height: optionHeight }}>
              <img src={icon} alt={name} />
              <span className={cx('small')}>{name}</span>
            </button>
          ))}
      </animated.div>
    </div>
  );
}
LangSwitcher.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggleOpen: PropTypes.func.isRequired,
  onOpened: PropTypes.func.isRequired,
  reverse: PropTypes.bool,
};
LangSwitcher.defaultProps = {
  reverse: false,
};
